<div id="map" #map></div>

<button mat-fab [mat-dialog-close]="data.lngLat" color="primary">
  <mat-icon>pin_drop</mat-icon>
</button>
